import React from "react";
import PropTypes from "prop-types";

import Navigation from "./nav/nav.components";
import Footer from "./footer/footer.components";

import "./custom.styles.scss";

const Layouts = (props) => {
  const { children } = props;

  return (
    <>
      <Navigation />
      <div className="space">{children}</div>
      {/* space because nav is fixed top and to put footer at the bottom*/}
      <Footer />
    </>
  );
};

Layouts.propTypes = {
  children: PropTypes.element,
};

export default Layouts;
